<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">确认删除</v-card-title>
        <v-card-text>
          <p>确定要删除以下校招信息吗？</p>
          <v-simple-table v-if="item">
            <template v-slot:default>
              <tbody>
                <tr>
                  <th>新闻标题</th>
                  <td>{{ item.newsTitle }}</td>
                </tr>
                <tr>
                  <th>工作地点</th>
                  <td>{{ item.workPlace }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">取消</v-btn>
          <v-btn color="error" @click="confirmDelete">确认删除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { adminApi } from '@/api/admin'

export default {
    name: 'DeleteIntershipNewsPopup',

    props: {
      item: {
          type: Object,
          required: true
      }
    },

    data() {
        return {
            dialog: false
        }
    },
    methods: {
        open() {
            this.dialog = true;
        },

        close() {
            this.dialog = false;
        },
        // 确认删除
        async confirmDelete() {
            try {
                const response = await adminApi.deleteIntershipNews(this.item.id);
                
                if (response.code === '2000') {
                    this.$emit('saved');
                    this.dialog = false;
                    this.$toast.success('删除成功');
                }
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.message || '未知错误';
                this.$toast.error('删除失败:', errorMessage);
            }
        },
    }
}
</script>